import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../api';
import { t } from '../i18n';
import { formatDateTime } from '@werkdelta/shared';

/** Audit-Einsicht je Fall (Auftrag 10). */
export function AuditPage() {
  const { caseId } = useParams<{ caseId: string }>();
  const [rows, setRows] = useState<any[] | null>(null);

  useEffect(() => {
    if (!caseId) return;
    api
      .get<any[]>(`/api/v1/cases/${caseId}/audit`)
      .then(setRows)
      .catch(() => setRows([]));
  }, [caseId]);

  return (
    <>
      <h1>{t('audit.title')}</h1>
      <p>
        <Link to={`/faelle/${caseId}/schritt/1`}>{t('audit.backToCase')}</Link>
        {' · '}
        <a href={`/api/v1/cases/${caseId}/audit.csv`}>{t('audit.exportCsv')}</a>
      </p>
      {rows === null ? (
        <p>{t('app.loading')}</p>
      ) : rows.length === 0 ? (
        <div className="leer-hinweis">{t('audit.empty')}</div>
      ) : (
        <div className="tabelle-scroll">
        <table className="daten">
          <thead>
            <tr>
              <th>{t('audit.when')}</th>
              <th>{t('audit.who')}</th>
              <th>{t('audit.action')}</th>
              <th>{t('audit.entity')}</th>
              <th>{t('audit.changes')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>{formatDateTime(r.createdAt)}</td>
                <td>{r.userEmail ?? 'System'}</td>
                <td>{r.action}</td>
                <td>{r.entityType}</td>
                <td>
                  {r.diff ? (
                    <details>
                      <summary>{Object.keys(r.diff).length} {t('audit.fields')}</summary>
                      <ul style={{ margin: '0.3rem 0' }}>
                        {Object.entries(r.diff as Record<string, { alt: unknown; neu: unknown }>).map(
                          ([field, d]) => (
                            <li key={field}>
                              <strong>{field}</strong>: {String(d.alt ?? '—')} → {String(d.neu ?? '—')}
                            </li>
                          ),
                        )}
                      </ul>
                    </details>
                  ) : (
                    '—'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </>
  );
}
